<ng-container *ngIf="config.sdkType === 'hostedFields'">
  <div class="input creditcard-indicator">
    <label class="required" i18n="@@payment_method.label.creditcard_number">
      Kreditkarten-Nummer
    </label>
    <div
      id="braintree-card-number-{{ uniqueInstanceId }}"
      class="form-control ng-dirty"
      [ngClass]="creditCardType$ | async"
      [class.ng-touched]="touchedByField$.number | async"
      [class.ng-invalid]="errorByField$.number | async"
      [class.ng-valid]="successByField$.number | async"
    ></div>
    <ng-container *ngIf="touchedByField$.number | async">
      <div
        class="error-container"
        *ngIf="errorByField$.number | async as error"
      >
        {{ error }}
      </div>
    </ng-container>
  </div>

  <div class="d-flex">
    <div class="input">
      <label class="required" i18n="@@payment_method.label.valid_to">
        Gültig bis
      </label>
      <div
        id="braintree-expiration-date-{{ uniqueInstanceId }}"
        class="form-control ng-dirty"
        [class.ng-touched]="touchedByField$.expirationDate | async"
        [class.ng-invalid]="errorByField$.expirationDate | async"
        [class.ng-valid]="successByField$.expirationDate | async"
      >
      </div>
      <ng-container *ngIf="touchedByField$.expirationDate | async">
        <div
          class="error-container"
          *ngIf="errorByField$.expirationDate | async as error"
        >
          {{ error }}
        </div>
      </ng-container>
    </div>

    <div class="input" id="creditcard_securitycode">
      <div class="label-container">
        <label i18n="@@payment_method.label.cvv" class="required">CVV </label>
        <a
          id="creditcard_securitycode_help"
          href="#"
          tabindex="-1"
          i18n="
            Es geht um die
            Kreditkartenprüfnummer@@lpayment_method.label.cvv_whats_this"
          (click)="$event.preventDefault(); cvcDialog.open()"
          >Was ist CVV?</a
        >
      </div>
      <div
        id="braintree-cvv-{{ uniqueInstanceId }}"
        class="form-control ng-dirty"
        [class.ng-touched]="touchedByField$.cvv | async"
        [class.ng-invalid]="errorByField$.cvv | async"
        [class.ng-valid]="successByField$.cvv | async"
      >
      </div>
      <ng-container *ngIf="touchedByField$.cvv | async">
        <div class="error-container" *ngIf="errorByField$.cvv | async as error">
          {{ error }}
        </div>
      </ng-container>
    </div>
  </div>

  <orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
</ng-container>

<div
  *ngIf="config.sdkType !== 'hostedFields'"
  id="braintree-container-{{ uniqueInstanceId }}"
></div>
